module.exports = __webpack_public_path__ + "img/蒙版组 121.61b96473.png";